import React from 'react';
import { Link } from 'react-router-dom';
import { QueryVal } from 'Helpers/Query';
import closeModal from 'Helpers/ModalHelper';
import Drawer from 'Components/Ant/Drawer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import LoadingRipple from 'Components/UI/LoadingRipple';
import Demographics from 'Components/AdvisorApp/Viewport/Household/LandingPage/Demographics';
import ActionItems from 'Components/AdvisorApp/Viewport/Household/LandingPage/Dashboard/NotesActionItems/ActionItems';
import DashboardNotes from 'Components/AdvisorApp/Viewport/Household/LandingPage/Dashboard/NotesGoalsAndInterests/Notes';
import QuickLinks from 'Components/AdvisorApp/Viewport/Household/LandingPage/Dashboard/NotesGoalsAndInterests/Links';
import { advisorHouseholdUri } from 'Consts/advisorUris';
import './index.css';
import AssetsManaged from './AssetsManaged';

const HouseholdFlyout = () => {
  const handleClose = () => {
    closeModal();
  };

  const {
    getPrimaryClient,
    householdResource,
    household,
  } = useSimpleHousehold();

  return (
    <Drawer visible width={500} onClose={handleClose} zIndex={1201}>
      <div className="HouseholdFlyout">
        {householdResource && household && household.id > 0 ? (
          <>
            <Demographics />
            <QuickLinks
              toggle={handleClose}
              primaryClientFirstName={getPrimaryClient().attr('firstName')}
              primaryClientLastName={getPrimaryClient().attr('lastName')}
              linkColor="primary"
            />
            <Link
              className="view-client"
              to={advisorHouseholdUri(QueryVal('householdId'))}
              onClick={handleClose}
              test="View Client Page"
            >
              View Client Page
            </Link>
            {householdResource.attributes.assetsUnderManagement > 0 && (
              <AssetsManaged />
            )}
            <DashboardNotes />
            <ActionItems toggle={handleClose} />
          </>
        ) : (
          <div>
            {`Loading household [${QueryVal('householdId')}]`} <LoadingRipple />
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default HouseholdFlyout;
